const mEditionBillingMyPaymentChangePlanModalPayMethods = {
  mEditionBillingMyPaymentChangePlanModalPayMethods: {
    alerts: {
      changePlan: {
        error: 'Un error ha ocurrido. Verifica los y vuelve a intentarlo.'
      }
    },

    header: {
      title: 'Medio de pago'
    }
  }
}

export default mEditionBillingMyPaymentChangePlanModalPayMethods
